import { defineMessages } from "react-intl";
export default defineMessages({
  monthlyReport: {
    "id": "reports.monthlyReport",
    "defaultMessage": "Monthly Report"
  },
  annualReport: {
    "id": "reports.annualReport",
    "defaultMessage": "Annual Report"
  },
  minTemperature: {
    "id": "reports.minTemperature",
    "defaultMessage": "Minimum temperature"
  },
  maxTemperature: {
    "id": "reports.maxTemperature",
    "defaultMessage": "Maximum temperature"
  },
  avgTemperature: {
    "id": "reports.avgTemperature",
    "defaultMessage": "Average temperature"
  },
  avgMinTemperature: {
    "id": "reports.avgMinTemperature",
    "defaultMessage": "Average T°min"
  },
  avgMaxTemperature: {
    "id": "reports.avgMaxTemperature",
    "defaultMessage": "Average T°max"
  },
  minTempMagnitude24h: {
    "id": "reports.minTempMagnitude24h",
    "defaultMessage": "Minimum Magnitude (/24H)"
  },
  maxTempMagnitude24h: {
    "id": "reports.maxTempMagnitude24h",
    "defaultMessage": "Maximum Magnitude (/24H)"
  },
  minHumidity: {
    "id": "reports.minHumidity",
    "defaultMessage": "Minimum humidity"
  },
  maxHumidity: {
    "id": "reports.maxHumidity",
    "defaultMessage": "Maximum humidity"
  },
  avgHumidity: {
    "id": "reports.avgHumidity",
    "defaultMessage": "Average humidity"
  },
  rainfall: {
    "id": "reports.rainfall",
    "defaultMessage": "Rainfall"
  },
  dailyMaxRainfall: {
    "id": "reports.dailyMaxRainfall",
    "defaultMessage": "Daily Max. rainfall"
  },
  rainyDays: {
    "id": "reports.rainyDays",
    "defaultMessage": "Rainy days"
  },
  longestRunWithoutRun: {
    "id": "reports.longestRunWithoutRun",
    "defaultMessage": "Longest run without rain"
  },
  longestRunOfRainyDays: {
    "id": "reports.longestRunOfRainyDays",
    "defaultMessage": "Longest run of rainy days"
  },
  minPressure: {
    "id": "reports.minPressure",
    "defaultMessage": "Minimum Pressure"
  },
  maxPressure: {
    "id": "reports.maxPressure",
    "defaultMessage": "Maximum Pressure"
  },
  avgPressure: {
    "id": "reports.avgPressure",
    "defaultMessage": "Average Pressure"
  },
  minPressureMagnitude24h: {
    "id": "reports.minPressureMagnitude24h",
    "defaultMessage": "Minimum Magnitude (/24H)"
  },
  maxPressureMagnitude24h: {
    "id": "reports.maxPressureMagnitude24h",
    "defaultMessage": "Maximum Magnitude (/24H)"
  },
  keyFacts: {
    "id": "reports.keyFacts",
    "defaultMessage": "Key Facts"
  },
  numberOfDays: {
    "id": "reports.numberOfDays",
    "defaultMessage": "Number of Days"
  },
  daysWithFrost: {
    "id": "reports.daysWithFrost",
    "defaultMessage": "Days with frost"
  },
  daysWithStrongFrost: {
    "id": "reports.daysWithStrongFrost",
    "defaultMessage": "Days with strong frost"
  },
  daysWithoutThaw: {
    "id": "reports.daysWithoutThaw",
    "defaultMessage": "Days without thaw"
  },
  maxTempGreaterThan: {
    "id": "reports.maxTempGreaterThan",
    "defaultMessage": "T°max ≥"
  },
  tropicalNights: {
    "id": "reports.tropicalNights",
    "defaultMessage": "Tropical nights"
  },
  tooDry: {
    "id": "reports.tooDry",
    "defaultMessage": "Too dry (Humidity ≤ 45%)"
  },
  comfortable: {
    "id": "reports.comfortable",
    "defaultMessage": "Comfortable (45% {lessThan} Humidity ≤ 60%)"
  },
  relativelyWet: {
    "id": "reports.relativelyWet",
    "defaultMessage": "Relatively wet (60% {lessThan} Humidity ≤ 80%)"
  },
  tooWet: {
    "id": "reports.tooWet",
    "defaultMessage": "Too wet (Humidity {greaterThan} 80%)"
  },
  lowPressure: {
    "id": "reports.lowPressure",
    "defaultMessage": "Low Pressure (Average Pressure {lessThan} 1013mbar)"
  },
  highPressure: {
    "id": "reports.highPressure",
    "defaultMessage": "Anticyclone (Average Pressure ≥ 1013mbar)"
  },
  analysis: {
    "id": "reports.analysis",
    "defaultMessage": "Analysis"
  },
  monthlyOutdoorReport: {
    "id": "reports.monthlyOutdoorReport",
    "defaultMessage": "Monthly Outdoor Report"
  },
  monthlyWindReport: {
    "id": "reports.monthlyWindReport",
    "defaultMessage": "Monthly Wind Report"
  },
  annualOutdoorReport: {
    "id": "reports.annualOutdoorReport",
    "defaultMessage": "Annual Outdoor Report"
  },
  monthlyIndoorReport: {
    "id": "reports.monthlyIndoorReport",
    "defaultMessage": "Monthly Indoor Report"
  },
  annualIndoorReport: {
    "id": "reports.annualIndoorReport",
    "defaultMessage": "Annual Indoor Report"
  },
  annualOutdoorComparison: {
    "id": "reports.annualOutdoorComparison",
    "defaultMessage": "Annual Outdoor Comparison"
  },
  annualIndoorComparison: {
    "id": "reports.annualIndoorComparison",
    "defaultMessage": "Annual Indoor Comparison"
  },
  dataExport: {
    "id": "reports.dataExport",
    "defaultMessage": "Export data"
  },
  dataExportXlsxFormatDescription: {
    "id": "reports.dataExportXlsxFormatDescription",
    "defaultMessage": "Export all of your station's data in Excel format (*.xlsx). Once you click on the button, you will receive an email with the processed data after a few minutes."
  },
  sendEmail: {
    "id": "reports.sendEmail",
    "defaultMessage": "Send email"
  },
  outdoorReport: {
    "id": "reports.outdoorReport",
    "defaultMessage": "Outdoor Report"
  },
  indoorReport: {
    "id": "reports.indoorReport",
    "defaultMessage": "Indoor Report"
  },
  emailSent: {
    "id": "reports.emailSent",
    "defaultMessage": "An email has been sent to your mailbox"
  },
  annualHeatingEfficiency: {
    "id": "reports.annualHeatingEfficiency",
    "defaultMessage": "Annual heating efficiency"
  },
  monthlyHeatingEfficiency: {
    "id": "reports.monthlyHeatingEfficiency",
    "defaultMessage": "Monthly heating efficiency"
  },
  annualCumulativeRainfall: {
    "id": "reports.annualCumulativeRainfall",
    "defaultMessage": "Annual cumulative rainfall"
  },
  annualCumulativeRainfallComparison: {
    "id": "reports.annualCumulativeRainfallComparison",
    "defaultMessage": "Annual Cumulative Rainfall Comparison"
  },
  yearToDateTemperature: {
    "id": "reports.yearToDateTemperature",
    "defaultMessage": "Year-to-date temperature"
  },
  yearToDateTemperatureComparison: {
    "id": "reports.yearToDateTemperatureComparison",
    "defaultMessage": "Year-to-date temperature comparison"
  },
  agroMeteorology: {
    "id": "reports.agroMeteorology",
    "defaultMessage": "Agrometeorology"
  },
  grasslandTemperatureSum: {
    "id": "reports.grasslandTemperatureSum",
    "defaultMessage": "Grassland temperature sum"
  },
  grasslandTemperatureSumDescription: {
    "id": "reports.grasslandTemperatureSumDescription",
    "defaultMessage": "If the sum of {threshold} is exceeded in spring, the sustainable start of vegetation has been reached (works in Europe)"
  },
  annualHeatingDurationComparison: {
    "id": "reports.annualHeatingDurationComparison",
    "defaultMessage": "Annual heating duration comparison"
  },
  monthlySolarReport: {
    "id": "reports.monthlySolarReport",
    "defaultMessage": "Monthly solar report"
  },
  annualSolarReport: {
    "id": "reports.annualSolarReport",
    "defaultMessage": "Annual solar report"
  },
  waterBalance: {
    "id": "reports.waterBalance",
    "defaultMessage": "Water balance"
  },
  annualWaterBalance: {
    "id": "reports.annualWaterBalance",
    "defaultMessage": "Annual water balance"
  },
  annualWaterBalanceDescription: {
    "id": "reports.annualWaterBalanceDescription",
    "defaultMessage": "The water balance (simplified version, only Rain and evapotranspiration are used) helps manage water supply"
  }
});